import { ImageStyleUriViewModel } from './image-style-uri.viewModel';
import { UriViewModel } from './uri.viewModel';

import type { FileField } from '@/src/cms/domain/models/fields/file-field/file-field';
import type { ImageStyleUri } from '@/src/cms/domain/models/fields/file-field/image-style-uri';


export class FileFieldViewModel {
  filename: string;

  meta: {
    alt?: string;
    title?: string;
  };
  uri: UriViewModel;

  imageStyleUri: ImageStyleUriViewModel;

  protected constructor(data: FileFieldViewModel) {
    this.filename = data.filename;
    this.meta = data.meta;
    this.uri = new UriViewModel(data.uri);
    this.imageStyleUri = new ImageStyleUriViewModel(data.imageStyleUri);
  }

  static presenter(
    entity: FileField,
    imageStyle: keyof ImageStyleUri = 'background'
  ): FileFieldViewModel {
    return new FileFieldViewModel({
      filename: entity.filename,
      imageStyleUri: entity.imageStyleUri || imageStyle,
      uri: entity.uri,
      meta: entity.meta || {}
    });
  }
}
